import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPermittedUrls = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M20.25 11.5V5.25H3.75V18.75H9C9.41421 18.75 9.75 19.0858 9.75 19.5C9.75 19.9142 9.41421 20.25 9 20.25H3.75C2.92157 20.25 2.25 19.5784 2.25 18.75V5.25C2.25 4.42158 2.92158 3.75 3.75 3.75H20.25C21.0784 3.75 21.75 4.42157 21.75 5.25V11.5C21.75 11.9142 21.4142 12.25 21 12.25C20.5858 12.25 20.25 11.9142 20.25 11.5Z",
			fill: "#5925C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21 8.25C21.4142 8.25 21.75 8.58579 21.75 9C21.75 9.41421 21.4142 9.75 21 9.75H3C2.58579 9.75 2.25 9.41421 2.25 9C2.25 8.58579 2.58579 8.25 3 8.25H21Z",
			fill: "#5925C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.8193 13.9004C22.1505 13.5244 22.7235 13.4883 23.0996 13.8193C23.4756 14.1505 23.5117 14.7235 23.1807 15.0996L16.5537 22.6279C16.3799 22.8252 16.1292 22.9375 15.8662 22.9355C15.6031 22.9335 15.3535 22.8173 15.1826 22.6172L11.3096 18.0801C10.9843 17.6989 11.03 17.1261 11.4111 16.8008C11.7923 16.4756 12.3651 16.5204 12.6904 16.9014L15.8828 20.6426L21.8193 13.9004Z",
			fill: "#5925C8"
		})
	]
});
export default SvgPermittedUrls;
